/**
 * Module dependencies.
 */

import React, { ReactNode } from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props<T> = {
  columns: Column<T>[];
};

/**
 * Export `Column` type.
 */

export type Column<T> = {
  title: string;
  size?: string;
  dataIndex?: string;
  key: string;

  render?: (item: T) => ReactNode;
};

/**
 * Export `Header` component.
 */

export function Header<T>({ columns }: Props<T>): JSX.Element {
  return (
    <div className={'contents max-[600px]:hidden'}>
      {columns.map((item: any, index: number) => {
        const { title, key, style } = item;

        return (
          <div
            className={cn(
              'flex items-center border-b-2 border-[#e2e5e9] bg-[#eef1f4] px-3 py-3 text-[11px] font-bold uppercase tracking-[0.06em] text-[#334155]',
              index === 0 && 'rounded-tl-lg',
              index === columns.length - 1 && 'rounded-tr-lg'
            )}
            key={key}
            style={typeof style === 'function' ? style() : style}
          >
            {title}
          </div>
        );
      })}
    </div>
  );
}
